import { screeningSteps, timelineSteps } from '../content'
import { Cta, Reassurance } from './Cta'

export function QualityProcess() {
  return (
    <>
      <section className="section section--mist" aria-labelledby="quality-title">
        <div className="container quality-layout">
          <div className="reveal">
            <p className="section-number">03 / Candidate quality</p>
            <h2 className="section-title" id="quality-title">
              Quality you can explain, not just claim.
            </h2>
            <p className="section-copy">
              Access qualified CA(SA) professionals, including candidates with
              experience at leading international audit firms. Every professional
              is evaluated for capability, communication and fit.
            </p>
          </div>
          <ol className="screening-track reveal">
            {screeningSteps.map((step, index) => (
              <li className="screening-item" key={step}>
                <span className="screen-icon">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section
        className="section section--dark"
        id="how-it-works"
        aria-labelledby="process-title"
      >
        <div className="container">
          <div className="process-head reveal">
            <div>
              <p className="section-number">04 / How it works</p>
              <h2 className="section-title" id="process-title">
                From first conversation to fully integrated.
              </h2>
            </div>
            <div className="button-wrap">
              <Cta>Explore your talent requirements</Cta>
              <Reassurance />
            </div>
          </div>
          <ol className="timeline reveal">
            {timelineSteps.map((step, index) => (
              <li className="timeline-item" key={step.title}>
                <span className="timeline-number">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  )
}
